import { ToggleButton } from '@mui/material';
import ButtonGroup from '../../Components/ButtonGroup';
import { Controller, useFormContext } from 'react-hook-form';
import { useEffect } from 'react';

function ButtonField({
    options,
    name,
    value,
    onChange,
    reverseSelected,
    renderOptionStyle = item => null,
    ...props
}) {
    const { resetField, control } = useFormContext();

    useEffect(() => resetField(name, { defaultValue: value }), [value]);

    return (
        <Controller
            control={control}
            name={name}
            defaultValue={value}
            render={({
                field: { onChange: controlerOnChange, value: controlerValue },
            }) => (
                <ButtonGroup
                    onChange={(e, value) => {
                        controlerOnChange({ target: { value }, name });
                        onChange(value || undefined);
                    }}
                    value={controlerValue}
                    {...props}
                >
                    {options.map(option => (
                        <ToggleButton
                            key={option.value}
                            value={option.value}
                            sx={renderOptionStyle(option)}
                            {...(reverseSelected && {
                                selected: value !== option.value,
                            })}
                        >
                            {option.label}
                        </ToggleButton>
                    ))}
                </ButtonGroup>
            )}
        />
    );
}

export default ButtonField;
